import Vue from 'vue';
import api from '../bu/api';
import moment from 'moment';

export default {
	namespaced: true,

	state: () => ({
		logistics: {},
		logisticsArray: [],
		rules: {}
	}),

	getters: {
		aliveLogistics(state) {
			return Object.values(state.logistics)
				.filter((l) => !l.deleted_at) 
				.sort((a, b) => a.order - b.order);
		},
		allLogistics(state) {
			return Object.values(state.logistics)
				.sort((a, b) => a.order - b.order);
		},
		logisticMap(state) {
			return state.logistics;
		},
		ruleMap(state) {
			return state.rules;
		}
	},

	actions: {
		async getLogistics({commit}) {
			const response = await api.getLogistics();
			commit('setLogistics', response.data);
			response.data.forEach((logistic) => {
				logistic.rules.forEach((rule) => {
					commit('setRule', rule);
				});
			})
			return response.data.map((logistic) => logistic.id);
		},
		async deleteLogistic({commit}, logisticId) {
			const response = await api.deleteLogistic(logisticId);
			commit('deleteLogistic', logisticId);
		},
		async saveLogistic({commit}, { logistic }) {
			const response = await api.saveLogistic(logistic);
			commit('setLogistic', response.data);
			return response.data;
		},
	},

	mutations: {
		setRule(state, rule) {
			Vue.set(state.rules, rule.id, rule);
		},
		setLogistic(state, logistic) {
			Vue.set(state.logistics, logistic.id, logistic);
			Vue.set(state, 'logisticsArray', Object.values(state.logistics));
		},
		setLogistics(state, logistics) {
			logistics.forEach((logistic) => {
				Vue.set(state.logistics, logistic.id, logistic);
			});
			Vue.set(state, 'logisticsArray', Object.values(state.logistics));
		},
		deleteLogistic(state, logisticId) {
			state.logistics[logisticId].deleted_at = moment().format('YYYY-MM-DD HH:mm:ss');
		}
	},
}